
import { useState } from 'react';
import { WebSearchStatus, WebSearchData } from '@/types/webSearch';

export const useWebSearchState = () => {
  const [searchData, setSearchData] = useState<WebSearchData | null>(null);
  const [searchStatus, setSearchStatus] = useState<WebSearchStatus | null>(null);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const [queuedAt, setQueuedAt] = useState<Date | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [progressValue, setProgressValue] = useState(0);
  const [refreshInterval, setRefreshInterval] = useState<number | null>(null);
  const [queuePosition, setQueuePosition] = useState<number | null>(null);

  return {
    searchData,
    setSearchData,
    searchStatus,
    setSearchStatus,
    lastUpdated,
    setLastUpdated,
    queuedAt,
    setQueuedAt,
    isLoading,
    setIsLoading,
    isProcessing,
    setIsProcessing,
    isInitialLoading,
    setIsInitialLoading,
    progressValue,
    setProgressValue,
    refreshInterval,
    setRefreshInterval,
    queuePosition,
    setQueuePosition,
  };
};
